module.exports = __webpack_public_path__ + "assets/37cd5debf6a79c15535ddc0c79fed5eb.png";